import * as type from '../ActionTypes';

const initialState = {
  adminClient: [],
  adminCoder: [],
  adminJobsData: [],
  adminProposalJobsData: [],
  currentCoder: null,
  adminCoderIsActiveFlag: null,
  adminClientIsActiveFlag: null,
  adminJobLoading: false,
  error: null,
  loading: false,
  topTableLoading: false
};

export default function adminReducer(state = initialState, action: any) {
  switch (action.type) {
    case type.INIT_ADMIN_CLIENT:
      return {
        ...state,
        loading: true,
        topTableLoading: false
      };
    case type.INIT_ADMIN_DETAIL:
      return {
        ...state,
        loading: false,
        topTableLoading: true
      };
    case type.GET_ADMIN_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        topTableLoading: false,
        adminClient: action.payload
      };
    case type.GET_ADMIN_CLIENT_FAILURE:
      return {
        ...state,
        loading: false,
        topTableLoading: false,
        adminClient: [],
        error: action.error
      };
    case type.RESET_ADMIN_CLIENT:
      return {
        ...state,
        adminClient: [],
        error: null,
        loading: true
      };

    case type.INIT_ADMIN_CODER:
      return {
        ...state,
        loading: true,
        topTableLoading: false
      };
    case type.SET_CURRENT_ADMIN_CODER:
      return {
        ...state,
        currentCoder: action.payload
      };
    case type.RESET_CURRENT_ADMIN_CODER:
      return {
        ...state,
        currentCoder: null
      };
    case type.GET_ADMIN_CODER_SUCCESS:
      return {
        ...state,
        loading: false,
        topTableLoading: false,
        adminCoder: action.payload
      };
    case type.GET_ADMIN_CODER_FAILURE:
      return {
        ...state,
        loading: false,
        topTableLoading: false,
        adminCoder: [],
        error: action.error
      };
    case type.PATCH_ADMIN_CODER_SUCCESS:
      return {
        ...state,
        loading: false,
        topTableLoading: false,
        adminCoderIsActiveFlag: action.payload
      };
    case type.PATCH_ADMIN_CODER_RESET:
      return {
        ...state,
        loading: false,
        topTableLoading: false,
        adminCoderIsActiveFlag: null
      };
    case type.PATCH_ADMIN_CODER_FAILURE:
      return {
        ...state,
        loading: false,
        topTableLoading: false,
        adminCoderIsActiveFlag: null,
        error: action.error
      };
    case type.PATCH_ADMIN_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        topTableLoading: false,
        adminClientIsActiveFlag: action.payload
      };
    case type.PATCH_ADMIN_CLIENT_RESET:
      return {
        ...state,
        loading: false,
        topTableLoading: false,
        adminClientIsActiveFlag: null
      };
    case type.PATCH_ADMIN_CLIENT_FAILURE:
      return {
        ...state,
        loading: false,
        topTableLoading: false,
        adminClientIsActiveFlag: null,
        error: action.error
      };
    case type.RESET_ADMIN_CLIENT:
      return {
        ...state,
        adminClient: [],
        error: null,
        topTableLoading: false,
        loading: false
      };

    case type.GET_ADMIN_JOB_REQUEST:
      return {
        ...state,
        topTableLoading: true,
        loading: false
      };
    case type.GET_ADMIN_JOB_SUCCESS:
      return {
        ...state,
        loading: false,
        topTableLoading: false,
        adminJobsData: action.data
      };
    case type.GET_ADMIN_JOB_FAILURE:
      return {
        ...state,
        loading: false,
        topTableLoading: false,
        adminJobsData: []
      };
    case type.RESET_ADMIN_JOB_REQUEST:
      return {
        ...state,
        loading: true,
        topTableLoading: true,
        adminJobsData: [],
        error: null
      };

    case type.GET_ADMIN_PROPOSAL_JOB_REQUEST:
      return {
        ...state,
        topTableLoading: true,
        loading: false
      };
    case type.GET_ADMIN_PROPOSAL_JOB_SUCCESS:
      return {
        ...state,
        topTableLoading: false,
        loading: false,
        adminProposalJobsData: action.data
      };
    case type.GET_ADMIN_PROPOSAL_JOB_FAILURE:
      return {
        ...state,
        loading: false,
        topTableLoading: false,
        adminProposalJobsData: [],
        error: action.error
      };
    case type.RESET_ADMIN_PROPOSAL_JOB_REQUEST:
      return {
        ...state,
        loading: true,
        topTableLoading: false,
        adminProposalJobsData: [],
        error: null
      };

    default:
      return state;
  }
}
